import { Component, OnInit } from '@angular/core';

import { AlertService } from './../../../../_services/services';

import { BookingRequest } from './../../../../_models/booking/booking-request.model';
import { Global } from 'src/app/globals';
import { Router } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared.module';
import { LoadingService } from 'src/app/_services/loading.service';

@Component({
  selector: 'app-booking-list',
  templateUrl: './booking-list.component.html',
  styleUrls: ['./booking-list.component.css'],
  standalone: true, // Required for Angular 18's new standalone components
  imports: [
    SharedModule,
    MaterialModule
  ]
})
export class BookingListComponent implements OnInit {
  bookingRequest: BookingRequest;
  bookingRequests: BookingRequest[];
  bookingStatus: string = 'pending';

  constructor(
    private router: Router,
    public globals: Global,
    private alertService: AlertService,
    private blockUI: LoadingService) {
    this.getBookings();
  }

  ngOnInit() {
  }

  getBookings() {
    this.blockUI.start();
    this.globals.signalR.FetchBookings(this.bookingStatus);
    this.globals.signalR.OnResponse('returnedBookingsList', this.onGetBookings.bind(this, this.bookingRequest));
  }

  onGetBookings(response: any) {

    console.log(response.transactionObject);
    if (response.errorMessage) {
      this.alertService.error("Server error. Fetching was not successful.");
      this.blockUI.stop();
      return;
    } else {
      if (response.transactionObject) {
        this.bookingRequests = response.transactionObject;
        this.blockUI.stop();
        return;
      } else {
        this.alertService.error("Agris Service error. Fetching was not successful.");
        this.blockUI.stop();
        return;
      }
    }
  }

  changeStatus(status: string) {
    console.log(status);
    this.bookingStatus = status;
    this.getBookings();
  }

  modifyBooking(booking: any) {
    localStorage.setItem('bookingIdEditable', JSON.stringify(booking));
    this.router.navigate(['booking']);
  }



}
